<template lang="pug">
  div.st-FlashReport_Icon_Plan(:style="`background-image: url('${image}')`")
    div.st-FlashReport_Icon_Plan_Icon
      component.sw-Icon(:is="comp")
</template>
<script>
  import SvgFootprints from '../../../../assets/images/svg/footprints.svg';
  import SvgHome from '../../../../assets/images/svg/home.svg';

  export default {
    components: {
      SvgFootprints,
      SvgHome,
    },
    props: {
      type: { type: String, default: 'footprints' },
      image: { type: String, default: '' },
    },
    computed: {
      comp() {
        if (this.type === 'footprints') {
          return 'svg-footprints';
        }
        return 'svg-home';
      },
    },
  };
</script>
